<template>
  <div v-cloak>
    <SaleAgentsTargetsPopup
      :show="saleAgentTargetsPopup"
      :agentTargets="selectedAgentData"
      @close="saleAgentTargetsPopup = false"
    ></SaleAgentsTargetsPopup>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex justify-end gap-2 mb-4">
          <vs-button
            @click.prevent="downloadExcelFile"
            class="bg_m_blue"
            :disabled="excelFileLoading"
            v-if="$tabHasPermission('GetAllSalesAgentsTargetsWithExcelFile')"
          >
            <div class="flex gap-2 items-center">
              <span>{{ $t("DownloadExcelFile") }}</span>
              <img
                v-if="excelFileLoading"
                src="@/assets/images/loading.gif"
                class="w-6 h-6"
              />
            </div>
          </vs-button>
          <div class="flex">
            <label class="custom-file-upload">
              <input
                type="file"
                id="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                ref="file"
                v-on:change="handleFileUpload"
              />
              <feather-icon
                icon="PaperclipIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              <span v-if="!uploadedFileName" class="pr-1">{{
                $t("ChooseFile")
              }}</span>

              <span v-if="uploadedFileName" class="file-name">{{
                uploadedFileName
              }}</span>
            </label>
            <vs-button
              @click="uploadFile"
              class="bg_m_green float-right whitespace-no-wrap"
              v-if="fileUploaded"
              :disabled="disabledUploadButton"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("UploadFile") }}
            </vs-button>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                {
                  title: $t('AgentName'),
                  total: 'TotalAmount',
                  name: 'TotalAmountByPaging',
                },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 50%">
                  {{ row.saleAgentInfo.saleAgentName }}
                </td>
                <td style="width: 50%">
                  <div class="flex justify-center items-center">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="flex gap-2 px-2 py-1"
                      @click="onAgentTargetsButton(row)"
                      >{{ $t("Targets") }}</vs-button
                    >
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import SaleAgentsTargetsPopup from "./SaleAgentsTargetsPopup.vue";

export default {
  components: {
    DataGrid,
    SaleAgentsTargetsPopup,
  },
  data() {
    const saleTargetId = this.$route.params.saleTargetId;
    const segmentTargetId = this.$route.params.segmentTargetId;
    return {
      gridDataSource: {
        type: "app",
        service: "/Sales/api/SaleTargetsQuery/saleAgentTargets",
      },
      gridSearchData: {
        saleTargetId: saleTargetId,
        segmentTargetId: segmentTargetId,
      },
      file: {
        name: "",
      },
      fileUploaded: false,
      uploadedFileName: "",
      disabledUploadButton: false,
      excelFileLoading: false,
      saleAgentTargetsPopup: false,
      selectedAgentData: [],
    };
  },
  methods: {
    ...mapActions({
      sendSaleTargetSegmentSaleAgentsExcelFile:
        "excel/sendSaleTargetSegmentSaleAgentsExcelFile",
      exportTargetSaleAgents: "excel/exportTargetSaleAgents",
    }),
    downloadExcelFile() {
      this.excelFileLoading = true;
      const params = {
        saleTargetId: this.$route.params.saleTargetId,
        segmentTargetId: this.$route.params.segmentTargetId,
      };
      this.exportTargetSaleAgents(params)
        .then(() => {
          this.excelFileLoading = false;
        })
        .catch(() => {
          this.excelFileLoading = false;
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.$refs.file.files[0].name;
      this.fileUploaded = true;
    },
    uploadFile() {
      const saleTargetId = this.$route.params.saleTargetId;
      const segmentId = this.$route.params.segmentTargetId;
      this.disabledUploadButton = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.sendSaleTargetSegmentSaleAgentsExcelFile({
        file: formData,
        saleTargetId: saleTargetId,
        segmentId: segmentId,
      })
        .then(() => {
          setTimeout(() => {
            this.$refs.grid.renderGrid(1, true);
          }, 500);
          setTimeout(() => {
            this.removeUploadFile();
            this.disabledUploadButton = false;
          }, 1000);
        })
        .catch(() => {
          this.removeUploadFile();
          this.disabledUploadButton = false;
        });
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.value = null;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    onAgentTargetsButton(row) {
      this.selectedAgentData = row.saleAgentTargetDetails;
      this.saleAgentTargetsPopup = true;
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
}
.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}
</style>
